module.exports = __webpack_public_path__ + "static/media/covi_per_han_san.c7747681.png";